import React from 'react';

class List_Branch_List extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <>
                <li className="branches-listing-row">
                    <div className="branches-listing-box">
                        <div className="branches-detail-box">
                            <h3 className="font-18 weight-600">{this.props.branchName}</h3>
                            <p className="font-15 text-color-666">{this.props.branchAddress}</p>
                        </div>
                        <div className="btn-area">
                            <button className="view-btn main-btn font-16 main-btn-reverse">{this.props.branchBtnText}</button>
                        </div>
                    </div>
                </li>
            </>
        );
    }
};

export default List_Branch_List;    